export enum SectionSelectionMode {
  ZoneMap,
  SameSection,
  CustomSections,
}
